<template>
  <v-card color="transparent" class="trendingNewsContainer" style="position: absolute">
    <v-row dense>
      <v-col cols="12" v-for="article in trendingNews" :key="article.title" >
        <v-card color="#124076" class="rounded-lg" dark v-if="article.source.id !== null">
          <v-card-title class="py-1">
            <v-icon small left>
              mdi-triangle
            </v-icon>
            <span class="text-subtitle-1 font-weight-light">{{ createSubstr(article.author, 20) }}</span>
            <v-spacer></v-spacer>
            <span class="text-subtitle-1 font-weight-light">
              {{ getTime(article.publishedAt) }}
            </span>
          </v-card-title>

          <v-card-text class="text-body-2 pb-0">
            <a :href="'' + article.url" target="_blank"
              style="all: unset; cursor: pointer; color: #FFF;">{{ article.title }}</a>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-list-item class="grow">
              <v-bottom-sheet width="1200px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn elevation="0" v-bind="attrs" v-model="sheet" v-on="on" color="transparent" density="compact"
                    padding="0px" class="pa-0" box-shadow="0px">
                    <v-list-item-avatar :size="35" color="white">
                      <v-img alt=""
                        src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=_blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"></v-img>
                    </v-list-item-avatar>
                  </v-btn>
                </template>
                <profilePage />
              </v-bottom-sheet>
              <v-list-item-content>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <a :href="'https://www.google.com/search?q=' + article.author"
                        style="text-decoration:none; color: white" target="_blank">
                        <v-list-item-title>{{ createSubstr(article.author, 10) }}</v-list-item-title></a>
                    </span>
                  </template>
                  <span>{{ article.author }}</span>
                </v-tooltip>
              </v-list-item-content>

              <v-row align="center" justify="end">
                <v-icon class="mr-1">
                  mdi-eye-outline
                </v-icon>
                <span class="caption mr-2">126M</span>
                <span class="mr-1">·</span>
                <v-icon class="mr-1">
                  mdi-chat
                </v-icon>
                <span class="caption">45k</span>
                <span class="mr-1">·</span>
                <v-icon class="mr-1" @click="postLike = !postLike" :color="postLike ? 'red' : 'none'">
                  mdi-heart
                </v-icon>
                <span class="caption mr-2">86k</span>
                <span class="mr-1">·</span>
                <v-menu v-model="fab" :top="top" :open-on-hover="hover" :transition="transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-model="fab" color="transparent" v-bind="attrs" v-on="on" @click="fav = !fav" elevation="0"
                      dark fab small>
                      <v-icon v-if="fab">
                        mdi-close
                      </v-icon>
                      <v-icon v-else>
                        mdi-share-variant
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-btn fab dark small color="primary">
                    <v-icon>mdi-send</v-icon>
                  </v-btn>
                  <v-btn fab dark small color="green">
                    <v-icon>mdi-whatsapp</v-icon>
                  </v-btn>
                  <v-btn fab dark small color="primary">
                    <v-icon>mdi-facebook</v-icon>
                  </v-btn>
                  <v-btn fab dark small color="primary">
                    <v-icon>mdi-link-variant</v-icon>
                  </v-btn>
                </v-menu>
                <span class="caption">73M</span>
              </v-row>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import profilePage from './profilePage'
// import navbar from './navbar'
const moment = require('moment')
moment().format()
export default {
  data: () => ({
    likesCounter: 0,
    postLike: false,
    sheet: false,
    article: [],
    top: "",
    fab: "",
    transition: "",
    hover: "",
  }),
  methods: {
    //subString creation
    //
    createSubstr(authors, i) {
      if (authors)
        return authors.substr(0, i)
    },
    // Add likes button and counter\
    //
    addlikes() {
      this.likesCounter++;
      this.postLike = !this.postLike;
    },
    getTime(publishedDate) {
      // Get todays date and the published date and find out how long
      // it's being since the article was posted.
      //
      //const m1 = new Date(); // prints: Toady's date
      const m2 = new Date(publishedDate) // prints: Date of article
      const timeFromNow = moment(m2).fromNow() // Returns time from when article was created
      return timeFromNow
    },
  },
  components: {
    profilePage,
  },
  props: {
    trendingNews: Array,
  },
}
</script>